const retailersState = {
  list: {},
  assets: {},
}

export default retailersState
